import React, { useEffect, useRef } from 'react';
import { Typography, CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import Header from '../Components/Header';
import api from '../../../services/api';
import { signInSuccess } from '../../../store/modules/auth/actions';
import { ApplicationState } from '../../../store';
import history from '../../../services/history';

export default function BillingSuccess() {
  const dispatch = useDispatch();
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const attemptsRef = useRef(0);

  useEffect(() => {
    const interval = setInterval(async () => {
      attemptsRef.current += 1;

      try {
        const res = await api.post('session/refresh');
        const { user } = res.data;

        if (user.isActive || (user.subscription && ['active', 'past_due', 'trialing'].includes(user.subscription.status))) {
          clearInterval(interval);
          dispatch(signInSuccess(user, token as any));
          history.push('/');
          return;
        }
      } catch (err) {
        // ignore, keep polling
      }

      // After 30 seconds (15 attempts), redirect anyway
      if (attemptsRef.current >= 15) {
        clearInterval(interval);
        history.push('/');
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [dispatch, token]);

  return (
    <>
      <Header />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          gap: '24px',
        }}
      >
        <Typography variant="h4" color="primary" style={{ fontWeight: 700 }}>
          Assinatura confirmada!
        </Typography>
        <Typography variant="body1" style={{ color: '#ffffffcc' }}>
          Ativando seu acesso...
        </Typography>
        <CircularProgress />
      </div>
    </>
  );
}
